module.exports = __webpack_public_path__ + "static/media/hard-hat.9bd179e8.svg";